import type { MailboxSettings } from '@recruitee/mailbox-types';
import { createSingleEntityStore } from '@recruitee/ngrx';

const { actions, reducer, namespace, selectors } =
  createSingleEntityStore<MailboxSettings | null>()('mailbox-settings');

const MailboxSettingsActions = <
  Pick<
    typeof actions,
    'fetch' | 'fetchSuccess' | 'fetchFailed' | 'update' | 'updateSuccess' | 'updateFailed'
  >
>actions;

export {
  MailboxSettingsActions,
  actions,
  reducer as MailboxSettingsReducer,
  namespace as MailboxSettingsNamespace,
  selectors as MailboxSettingsSelectors,
};
